import { Stack, Text } from '@chakra-ui/react'

import Alert from '@/components/UI/Alert'

export function ContactInfoAlert(): JSX.Element {
  return (
    <Alert variant="info-blue" preserveFontWeight>
      <Stack spacing="8px">
        <Text>
          Here is the information you may need to add to your school&apos;s volunteer forms /
          external platform:
        </Text>
        <Stack spacing="0px">
          <Text>
            <b>Supervisor Name:</b> Matt Wu
          </Text>
          <Text>
            <b>Email:</b> volunteering@schoolhouse.world
          </Text>
          <Text>
            <b>Phone Number:</b> (650) 360-8242 [only for phone calls, not SMS]
          </Text>
          <Text>
            <b>Federal Employer Identification #:</b> 85-3101725
          </Text>
          <Text>
            <b>Address:</b> 3790 El Camino Real Unit PMB 544, Palo Alto, CA 94306
          </Text>
        </Stack>
      </Stack>
    </Alert>
  )
}
